(function() {
  "use strict";

  angular.module("sempraWebapp").constant("huTranslations", {
    MESSAGE:"Üzenet",
    ERROR_TITLE:"Hiba",
    ERROR_MESSAGE:"Hiba történt a művelet végrehajtása során.",
    ERROR_LOGIN:"Hiba történt a bejelentkezés során. Érvénytelen e-mail cím",
    ERROR_LOGIN_ROLE:"Az applikáció és a márka szerepköre nem érvényes",
    OK:"Rendben",
    CANCEL:"Mégse",
    YES:"Igen",
    NO:"Nem",
    FROM:"Innentől:",
    TO:"Idáig:",
    DELETE:"Törlés",
    SIGN_OUT:"Kijelentkezés",
    NAME:"Név",
    DATE:"Dátum",
    PIECES:"darab",
    HOURS:"óra",
    DAYS:"nap",
    MONTH:"hónap",
    MONTHS:"hónap",
    YEAR:"év",
    BOX:"beálló",
    SEARCH:"Keresés",
    ALL_USERS:"Minden felhasználó",
    ARE_YOU_SURE:"Biztos benne",
    BACK:"Vissza",
    AMOUNT:"Összeg",
    DESCRIPTION:"Leírás",
    FORGOT_PASSWORD_ERROR_MSG:"Hiba történt. Kérjük, hogy ellenőrizze e-mail címét és próbálja újra!",
    REQUIRED_FIELD:"A mező kitöltése kötelező",
    LOGOUT_TITLE:"Biztosan ki akar jelentkezni?",
    LOGOUT_MSG:"Minden el nem mentett adata elveszik",
    ACTIVATION_ACCOUNT:"Sikeresen aktiválta felhasználói fiókját",
    UNKNOWN_ERRROR_NOTIFICATION:"Ismeretlen hiba történt",
    CONTINUE:"Folytatás",
    DATA_NOT_AVAILABLE:"Nem áll rendelkezésre adat",
    SELECT:"Kiválasztás ",
    SELECT_CURRENCY:"Válasszon pénznemet",
    UPLOAD:"Feltöltés",
    PHONE:"Telefon",
    WEBSITE:"Webhely",
    WORKING_HOURS:"Nyitvatartási idő",
    INSERT:"Beillesztés",
    TEXT:"Szöveg",
    CREATED:"Létrehozva",
    VALID_UNTIL:"Érvényes eddig:",
    SAVE:"Mentés",
    TOKENS:"Zsetonok",
    DELETE_COMPANY_HISTORY:"Vállalat előtörténetének törlése?",
    DELETE_COMPANY_HISTORY_MESSAGE:"FIGYELMEZTETÉS: A gomb megnyomása után az autómosó összes tranzakciója véglegesen törlődik! Ezek az adatok törlés után nem állíthatók vissza.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Biztos benne, hogy véglegesen törölni szeretné az összes tranzakciós adatot?",
    HISTORY_SUCCESSFULY_DELETED:"Az előtörténet törlése sikeres volt.",
    HELP:"Segítség",
    VALUE:"Érték",
    ACTIVATING_ACCOUNT_ERROR:"Az R2W felhasználói fiókja aktiválása során hiba történt. Kérjük, hogy próbálja újra, és ha a hiba továbbra is fennáll, lépjen kapcsolatba ügyfélszolgálatunkkal a support@ready2wash.com címen!",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Üdvözöljük a Kärcher Autómosó",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Üdvözöljük a R2W-nél!",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Írja be az új jelszavát, és erősítse meg, hogy aktiválja az R2W fiókját! Ha ezt sikerrel végrehajtja, automatikusan bejelentkezik az alkalmazásba",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Később, az alkalmazásban módosíthatja felhasználói beállításait",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher autómosó",
    RESET_PASSWORD_WELCOME_MSG:"R2W autómosó",
    RESET_PASSWORD_WELCOME_MSG_2:"Kérjük, adja meg új jelszavát, és erősítse meg a régi jelszó visszaállításához. Sikeres esetben automatikusan bejelentkezik az alkalmazásba",
    RESET_PASSWORD_WELCOME_MSG_3:"A felhasználói beállításokat később az alkalmazásban módosíthatja",
    ENTER_NEW_PASSWORD:"Új jelszó megadása",
    REPEAT_NEW_PASSWORD:"Új jelszó ismét",
    PASSWORD_MIN_LENGTH:"A jelszónak legalább 8 karakterhosszúnak kell lennie",
    PASSWORD_MAX_LENGHT:"A jelszó nem lehet 32 karakternél hosszabb",
    PASSWORD_PATTERN:"A jelszónak tartalmaznia kell legalább egy nagybetűt és egy kisbetűt",
    PASSWORD_MATCH:"A jelszók nem egyeznek",
    ACTIVATE:"Aktiválás",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Sikeresen elküldte a kérést. Kérjük, ellenőrizze e-mailben a megerősítő üzenetet",
    VALIDATION_REQUIRED:"Kötelezően kitöltendő mező",
    VALIDATION_EMAIL:"Érvénytelen e-mail cím",
    VALIDATION_INTEGER_NUMBER:"Kérjük, hogy egész számot adjon meg",
    VALIDATION_HOURS_VALUE:"Az értéknek 0 és 23 között kell lennie",
    VALIDATION_MINUTES_VALUE:"Az értéknek 0 és 59 között kell lennie",
    VALIDATION_NOT_A_DATE:"A megadott érték nem dátum",
    VALIDATION_FROM:"    utáni dátumtól",
    VALIDATION_TO:"   előtti dátumig",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Ez az adat már szerepel az adatbázisban",
    PASSWORD_VALIDATION_PATTERN_NEW:"Tartalmaznia kell legalább egy számjegyet, egy kisbetűt és egy nagybetűt Szóközt nem tartalmazhat",
    VALIDATION_PERCENT_VALUE:"Az értéknek 1 és 999 között kell lennie",
    NUMBERS_ONLY_100:"Csak egy pozitív szám 100-ig",
    NUMBERS_ONLY_1000:"Csak egy pozitív szám 1000-ig",
    POSITIVE_NUMBERS_ONLY:"Csak egy pozitív szám",
    GRID_PAGER_PAGE:"Oldal",
    GRID_PAGER_ROWS_PER_PAGE:"Sorok egy oldalon",
    GRID_PAGER_PAGE_OF:"közül",
    BREAD_CRUMBS_HOME:"Főoldal",
    BREAD_CRUMBS_DASHBOARD_TECH:"Irányítópult (dashboard) technológia",
    BREAD_CRUMBS_DETAILS:"Adatok",
    BREAD_CRUMBS_SETTINGS:"Beállítások",
    BREAD_CRUMBS_WORKING_HOURS:"Munkaidő",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Teljes pénzösszeg kimutatása napi bontásban",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Átlagos pénzösszeg kimutatása óránkénti bontásban",
    BREAD_CRUMBS_NEW_USER_GROUP:"Felhasználói csoport létrehozása",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Felhasználói csoport szerkesztése",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Kampány-sablon létrehozása",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Kampány-sablon szerkesztése",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Kampány létrehozása",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Kampány szerkesztése",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Időszaki összegzés",
    LOGIN:"Bejelentkezés",
    EMAIL:"E-mail",
    PASSWORD:"Jelszó",
    LANGUAGE:"Nyelv",
    FORGOT_PASSWORD:"Elfelejtette a jelszavát?",
    SUBMIT:"Küldés",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Folyamatban levő riasztások száma:",
    HEADER_VIEW_ALL_ALARMS:"Az összes riasztás megtekintése...",
    HEADER_MY_ACCOUNT:"Fiókom",
    HEADER_ACCOUNT_MANAGEMENT:"Felhasználói fiók kezelése",
    ACCOUNT_ALREADY_EXIST:"Már használatban levő e-mail cím",
    NEWSLETTER_CONFIRMATION:"E-mail értesítés küldése a riasztások állapotáról",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Napi pénzügyi áttekintése",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Irányítópult (dashboard) technológia",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Irányítópult",
    ASIDE_MENU_ALARMS:"Üzenetek",
    ASIDE_MENU_FACILITIES:"Autómosók",
    ASIDE_MENU_REPORTS:"Kimutatások",
    ASIDE_MENU_REPORT:"Kiválasztott kimutatás",
    ASIDE_MENU_LOYALTY:"Hűségprogram",
    ASIDE_MENU_USER_GROUPS:"Felhasználói csoportok",
    ASIDE_MENU_PERIODIC_SUMMARY:"Időszaki összegzés",
    ASIDE_MENU_MANAGING_TOKENS:"Zsetonok kezelése",
    ASIDE_MENU_NEWS:"Hírek",
    DAILY_FINANCES_TOTAL_MONEY:"Teljes pénzösszeg",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Teljes pénzösszeg az összes autómosóra vonatkozóan",
    DAILY_FINANCES_TOTAL_COINS:"Felhasznált fém zsetonok összesen",
    DAILY_FINANCES_DOWNLOAD_CSV:"CSV-fájl letöltése",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Készpénz",
    DAILY_FINANCES_CHANGER:"Készpénz a pénzváltóban",
    DAILY_FINANCES_COINS:"Zsetonok/Eurokey",
    REPORTS_FILTER:"Szűrő",
    REPORTS_TYPE_OF_REPORT:"Kimutatás típusa",
    REPORTS_CHOOSE_FACILITY:"Autómosó kiválasztása",
    REPORTS_PERIOD_1:"1. időszak -",
    REPORTS_PERIOD_2:"2. időszak -",
    MONEY_BY_DATE_REPORT:"Teljes bevétel dátumokra lebontva",
    R2W_BY_DATE_REPORT:"Összes elköltött R2W zseton dátumokra lebontva",
    COINS_BY_DATE_REPORT:"Bankkártyás forgalom",
    AVG_MONEY_BY_HOUR_REPORT:"Átlagos bevétel órákra lebontva",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Átlagos bevétel a hét napjaira lebontva",
    AVG_MONEY_BY_BOX_REPORT:"Forgalom beállónként",
    COMPARE_PERIODS_REPORT:"Autómosó összehasonlító kimutatás",
    TOTAL_USERS_BY_GROUP:"Az R2W alkalmazás felhasználói összesen, napokra lebontva",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"felhasználók",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"látogatók",
    VISITS_COUNT_REPORT:"Az R2W alkalmazás felhasználók száma látogatásonként",
    LOYALTY_PER_DAY_REPORT:"Naponta elköltött helyi zsetonok száma",
    LOYALTY_PER_PAYMENT_METHOD:"Az egyes fizetési módokra jutó kiadott helyi zsetonok száma",
    VISITS:"Látogatások",
    VISIT:"Látogatás",
    TOTAL_SPENT_MONEY:"Teljes bevétel",
    MONEY:"Pénz",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Az időszak során költött teljes pénzösszeg",
    DOWNLOAD_CSV:"CSV-fájl letöltése",
    TOTAL_SPENT_COINS:"Forgalom összesen",
    TOTAL_USERS:"Felhasználók összesen",
    TOTAL_CREDIT_GIVEN:"Összesen elköltött helyi virtuális zsetonok",
    EUROKEY_BY_DATE_REPORT:"Eurokey kifizetések összesen, dátumokra lebontva",
    TOTAL_SPENT_EUROKEY:"Teljes költés",
    SELECT_TYPE_OF_REPORT:"Ki kell választania a jelentés típusát :)",
    NUMBER_OF_VISITS_TITLE:"Látogatások száma",
    NUMBER_OF_USERS_TITLE:"Felhasználók száma",
    PIECES_TITLE:"Darabok",
    TOTAL_VISITS:"Összes látogatás",
    TOKENS_TITLE:"zseton",
    SEARCH_USERS_NO_RESULTS:"A megadott keresési szó alapján nem található felhasználó",
    SEARCH_USERS:"Felhasználók keresése",
    SEARCH_TELEPHONES:"Felhasználók keresése mobilszám alapján",
    ADD_USER_TO_GROUP:"Felhasználó hozzáadása csoporthoz",
    REMOVE_USER_FROM_GROUP:"Felhasználó törlése csoportból",
    USER_GROUP_NAME_REQUIRED:"A felhasználói csoport neve kötelezően kitöltendő",
    USER_GROUP_NAME:"Felhasználói csoport neve",
    USER_GROUPS_OVERVIEW:"Felhasználói csoportok áttekintése",
    USER_COUNT:"Felhasználók száma",
    NEW_USER_GROUP:"Új felhasználói csoport létrehozása",
    DELETE_USER_GROUP:"Felhasználói csoport törlése",
    UPDATE_USER_GROUP:"Felhasználói csoport szerkesztése",
    DELETE_USER_GROUP_ERROR:"Hiba történt a kiválasztott felhasználói csoport törlése során. Kérjük, próbálja újra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal...",
    CONFIRM_DELETE_USER_GROUP:"Biztosan törölni akarja a kiválasztott felhasználói csoportot?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"A továbbiakban nem érvényesek azok a hűségprogram-akciók, amelyekhez a törölt felhasználói csoport hozzá volt rendelve.",
    GROUP_NAME_MAX_LENGTH:"A csoport neve nem lehet 255 karakternél hosszabb",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"A felhasználó már tagja a csoportnak",
    MISSING_USER:"Hiányzó felhasználó",
    USER_NOT_ON_LIST:"A felhasználó nem szerepel az aktív felhasználók listáján. Ellenőrizze, hogy az e-mail cím érvényes-e, és próbálja újra.",
    UPLOAD_USER_GROUP:"A *.csv fájlból töltse fel a felhasználócsoport-listát",
    UKNOWN_USERS:"Ismeretlen felhasználók listája",
    CAMPAIGN_TEMPLATE_RULE:"Sablon-szabály",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Hiba történt a kampány-sablon törlése során. Kérjük, próbálja újra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Biztosan törölni akarja a kiválasztott kampány-sablont?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Biztosan törölni akarja a kiválasztott kampány-sablont?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Kampány-sablonok áttekintése",
    DELETE_CAMPAIGN_TEMPLATE:"Kampány-sablon törlése",
    UPDATE_CAMPAIGN_TEMPLATE:"Kampány-sablon szerkesztése",
    CREATE_CAMPAIGN_TEMPLATE:"Új kampány-sablon létrehozása",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Kötelező  nevet adni a kampány-sablonnak",
    CAMPAIGN_TEMPLATE_NAME:"Kampány-sablon neve",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Kötelezően kitöltendő mező",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"kiadott %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"többletidő",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Először válassza ki a típust. Mosódobozok vagy kisgépek.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Sablon-szabály törlése",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Innentől:",
    CAMPAIGN_TEMPLATE_RULE_TO:"-ig",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"óra múlva",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"perc",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Új szabály a látogatások száma szerinti bontásban",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Új szabály az elköltött zsetonok összege szerinti bontásban",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Új szabály a hét napjai szerinti bontásban",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Új sablon-szabály hozzáadása",
    CAMPAIGN_TEMPLATE_RULE_1:"Minden",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Minden",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"elköltött zseton kevesebb mint alatt",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"látogatások kevesebb mint alatt",
    CAMPAIGN_TEMPLATE_RULE_3:"nap",
    CAMPAIGN_TEMPLATE_RULE_4:"zsetonok",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"A szabálylista üres.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"A dátum nem lehet múltbeli időpont.",
    DELETE_CAMPAIGN_ERROR:"Hiba történt a kampány törlése során. Kérjük, próbálja újra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal...",
    CONFIRM_DELETE_CAMPAIGN:"Biztosan törölni akarja a kiválasztott kampányt?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"Az R2W nem felelős az ezen művelet okozta felhasználói élményért.",
    CAMPAIGNS_OVERVIEW:"Kampányok áttekintése",
    DELETE_CAMPAIGN:"Kampány törlése",
    UPDATE_CAMPAIGN:"Kampány szerkesztése",
    CREATE_CAMPAIGN:"Új kampány létrehozása",
    CAMPAIGN_ACTIVE:"Aktív",
    CAMPAIGN_TEMPLATE:"Sablon",
    CAMPAIGN_GROUPS:"Csoportok",
    CAMPAIGN_ALL_USERS:"Minden felhasználó",
    CAMPAIGN_NAME:"Kampány neve",
    CAMPAIGN_NAME_REQUIRED:"Kötelezően kitöltendő",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Az értékhatárt megközelítő felhasználók száma napi bontásban",
    MESSAGE_TO_USERS:"Üzenet a felhasználók megszűrt körének",
    SEND_MESSAGE:"Üzenet küldése",
    THRESHOLD:"Értékhatár",
    TYPE:"Típus",
    TOTAL_MONEY_SPENT:"A kampány során elköltött teljes pénzösszeg",
    NUMBER_OF_VISITS:"A kampányhoz kapcsolódó látogatások száma ",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"A jelszónak legalább 10 karakter hosszúnak kell lennie",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Az üzenet nem lehet 350 karakternél hosszabb",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Szöveges üzenetet kell küldeni",
    TECHNOLOGY:"Technológia",
    TAP_WATER:"Csapvíz",
    REVERSE_OSMOSIS:"Fordított ozmózis",
    SOFTENED_WATER:"Lágyított víz",
    DOSER:"Adagoló",
    STATUS:"Státusz",
    LAST_SYNCHRONIZATION:"Utolsó szinkronizálás",
    NO_OF_CURRENT_ALARMS:"Aktuális riasztások száma",
    NO_OF_CURRENT_WARNINGS:"Aktuális figyelmeztetések száma",
    WEATHER:"Időjárás",
    BOXES_WORK_HOURS_COUNTERS:"Beállók üzemórái",
    BOX_TOTAL_HOURS:"Üzemórák összesen",
    BOX_SERVICE_HOURS:"Üzemórák összesen (szolgáltatás)",
    BOX_COUNTER_HOURS:"óra múlva",
    ALARMS_AND_WARNINGS:"Riasztások és figyelmeztetések",
    FILTER_AND_BOILER:"Szűrő és vízmelegítő",
    FILTER_TOTAL_DAYS:"Szűrő üzemi napok",
    BOILER_TOTAL_DAYS:"Vízmelegítő üzemi napok",
    DAYS_UNIT:"nap",
    SOFTENER:"Vízlágyító",
    MANUAL_COLD_DRAIN:"Manuális kifolyóvíz-visszahűtő",
    EL_COLD:"Elektromos kifolyóvíz-",
    DRAIN:"visszahűtő",
    TAP:"csap",
    WASTE:"Szennyvíz",
    OSMOSIS:"ozmózis",
    DEMI_WATER:"Ioncserélt víz",
    EL_RINSE:"Elekt. öblítés",
    BOILER:"Vízmelegítő",
    EL_WAX:"Elekt. viaszolás",
    FLOOR_HEATING:"Padlófűtés",
    DOSER_TANK:"Adagolótartály",
    EL_WASH:"Elekt. mosás",
    DETERGENT:"Mosószer",
    VIBRATOR:"Rezgőadagoló berendezés",
    UPDATE_FACILITY_SETTINGS:"Beállítások frissítése",
    GENERAL_SETTINGS:"Általános beállítások",
    LIGHTS:"Lámpák",
    GROUPS:"Csoportok",
    ANTI_FREEZE:"Fagyálló",
    AUTO:"Automata",
    MANUAL:"Manuális",
    ON:"Be",
    OFF:"Ki",
    TEMPERATURE:"Hőmérséklet",
    UPDATE_DEVICE:"Autómosó beállítások frissítése",
    BOX_CLEAN_HOURS:"Beállók tisztítási számlálói (óra)",
    GROUP_COUNTERS:"Csoport számlálók",
    RESET:"Visszaállítás",
    CASH_COUNT:"Érmék száma",
    COINS_COUNT:"Zsetonok száma",
    EUROKEY_COUNT:"Eurokey szám",
    DOSER_WORK:"Adagoló üzemideje (másodperc)",
    DOSER_PAUSE:"Adagoló állásideje (másodperc)",
    DELAY_BFV:"BFV késleltetés (perc)",
    DELAY_6M1:"6M1 késleltetés (perc)",
    DELAY_LPS:"LPS késleltetés (perc)",
    RESET_CASH_COUNT_ALL:"Minden érmeszámláló alaphelyzetbe állítása",
    RESET_COINS_COUNT_ALL:"Minden zsetonszámláló alaphelyzetbe állítása",
    RESET_EUROKEY_COUNT_ALL:"Minden Eurokey-számláló alaphelyzetbe állítása",
    FACILITY_DETAILS:"Autómosó adatai",
    FACILITY_NAME:"Autómosó neve",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"A képfeltöltése sikeres volt",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Az adatfeltöltése sikeres volt",
    CONNECTED:"Csatlakoztatva",
    DISCONNECTED:"Lecsatlakoztatva",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Üzenetszűrő",
    FACILITY:"Autómosó",
    APPLY:"Alkalmaz",
    TIME:"Idő",
    LOCATION:"Hely",
    ACKNOWLEDGED:"Visszaigazolva",
    FILTERED_MESSAGES:"Szűrt üzenetek",
    ACK:"Visszaigazolva",
    NOT_ACK:"Nincs visszaigazolva",
    ALL:"Mind",
    ALL_FACILITIES:"Összes autómosó",
    ENTER_DATE_PLACEHOLDER:"Dátum megadása",
    OP_NESTANAK_NAPONA:"Feszültséghiány az 3A5 fázisjelzőnél",
    OP_OTB_PUMPA_GRESKA_MZS:"Nagynyomású szivattyú áramköri megszakítója lekapcsolt",
    OP_UPR_NAPON_24VAC_GRE:"24 VAC feszültséghiány - 5F1.1 áramköri megszakító",
    OP_MIN_NIVO_PITKA_VODA:"Frissvizes tartály üres",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Fő vízvezeték szivattyú áramköri megszakítója lekapcsolt",
    OP_MIN_NIVO_OMEKS_VODE:"Lágyított vizes tartály üres",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Lágyítottvíz-szivattyú áramköri megszakítója lekapcsolt",
    OP_MIN_NIVO_DEMIN_VODE:"Ozmózis berendezés víztartálya üres",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Ozmózis berendezés szivattyújának áramköri megszakítója lekapcsolt",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Ozmózis berendezés szivattyújának áramköri megszakítója lekapcsolt",
    OP_BOJLER_GRESKA_MZS:"Vízmelegítő hibája",
    OP_CRPKA_PRASKA_GRE_MZS:"Forróvíz-szivattyú áramköri megszakítója lekapcsolt",
    OP_DOZATOR_PRASKA_GRE_MZS:"Poradagoló motor áramköri megszakítója lekapcsolt",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Rezgő poradagoló áramköri megszakítója lekapcsolt",
    OP_MIN_PRASAK_TON_ALARM:"Porkeverő tartály üres",
    OP_USIS_KOV_TURBINA_GRESKA:"Érme vákuumos berendezés turbinájának áramköri megszakítója lekapcsolt",
    OP_FILTER_VODE_ZACEPLJEN:"Vízszűrő eltömődött",
    OP_VISKTL_RESET_SATI_RADA:"Nagynyomású szivattyú szervíz",
    OPW_VISKTL_RESET_SATI_RADA:"Nagynyomású szivattyú szervíz",
    OP_FILTER_DANI_RADA:"Vízszűrő hiba",
    OP_BOJLER_DANI_RADA:"Vízmelegítő hiba",
    OPW_ALARM_VISOKOTL_PUMPA:"Nagynyomású szivattyú riasztás",
    OPW_ALARM_FILTER_SERVIS:"Szűrő szervíz riasztás",
    OPW_ALARM_BOJLER_SERVIS:"Vízmelegítő szervíz riasztás",
    HAS_MEMBERS:"A kiválasztott csoportnak vannak tagjai, ezért nem törölhető. Először a tagokat kell törölni.",
    PERIODIC_SUMMARY_FOR:"IDŐSZAKI R2W JELENTÉS",
    PERIODIC_SUMMARY_REPORTS:"Időszaki összegfoglaló jelentések",
    DATE_RANGE:"Dátumtartomány",
    FINANCIAL_REPORT:"Pénzügyi beszámoló",
    GROSS_INCOME:"Bruttó bevétel",
    GROSS_INCOME_SUM:"Bruttó bevétel összesen",
    COMMISSION_FEE:"Jutalékok, díjak",
    NET_INCOME:"Nettó bevétel (számlázásból)",
    COMMISSION_FEE_DETAILS:"A jutalékok, díjak a banki /Paypal szolgáltatás, ill. SMS szolgáltatók díját foglalja magában.",
    LOYALTY_CREDITS_REPORT:"Helyi zsetonforgalmi jelentés",
    LOYALTY_GIVEN:"Kiadott helyi zsetonok",
    LOYALTY_USED:"Felhasznált helyi zsetonok",
    LOYALTY_SOLD:"Betöltött helyi zsetonok",
    LOYALTY_TOTAL:"Összesen",
    LOYALTY_CURRENT_MONTH:"Tárgyhó",
    SOMETHING_WENT_WRONG:"Hoppáááá",
    MISSING_PAGE:"Sajnáljuk. Nem találtuk a megadott oldalt",
    TRY_AGAIN:"Próbálja újra!",
    DEFAULT_ERROR_NAME:"Ismeretlen hiba történt",
    DEFAULT_ERROR_DESCRIPTION:"Kérjük, próbálja újra!",
    MY_ACCOUNT_DETAILS:"Felhasználói fiókom adatai",
    SAVE_CHANGES:"Változások mentése",
    USERNAME:"Felhasználói név",
    FIRST_NAME:"Utónév",
    LAST_NAME:"Vezetéknév",
    USER_ROLE:"Felhasználói szerep",
    OLD_PASSWORD:"Régi jelszó",
    NEW_PASSWORD:"Új jelszó",
    OLD_PASSWORD_REQUIRED:"A régi jelszót kell megadni",
    NEW_PASSWORD_REQUIRED:"Új jelszót kell megadni",
    NEW_PASSWORD_REPEAT:"Az új jelszót újra meg kell adni",
    NEW_PASSWORD_NOT_MATCH:"A régi és az új jelszó nem egyezik",
    PASSWORD_DIFFERENT_VALIDATION:"Az új jelszónak el kell térnie a régitől",
    PASSWORD_MIN_CHAR:"Az Ön jelszavának legalább 8 karakter hosszúnak kell lennie",
    PASSWORD_MAX_CHAR:"Az Ön jelszava legfeljebb 32 karakter hosszú lehet",
    PASSWORD_PATTERN_VALIDATION:"A jelszónak tartalmaznia kell legalább egy számjegyet",
    ACCOUNT_MANAGEMENT:"Felhasználói fiók kezelése",
    NOT_ACTIVE:"Inaktív",
    ASSIGN_ROLE:"Feladatkör hozzárendelése",
    UPDATE:"Frissítés",
    ADD_NEW_ACCOUNT:"Új felhasználói fiók hozzáadása",
    EMAIL_REQUIRED:"E-mail cím szükséges",
    EMAIL_NOT_VALID:"Érvénytelen e-mail cím",
    ADD_NEW_USER_TEXT:"A megadott e-mail címre e-mailt küldünk az aktiváláshoz szükséges hivatkozással",
    UPDATE_USER_NOTIFICATION:"Az adatfeltöltése sikeres volt",
    CHANGED_PASSWORD_NOTIFICATION:"Sikeresen módosította jelszavát",
    UPDATE_USER_GROUP_NOTIFICATION:"Sikeresen módosította a felhasználói csoport nevét",
    CREATE_USER_GROUP_NOTIFICATION:"Sikeresen létrehozta a csoportot",
    DETELE_USER_GROUP_NOTIFICATION:"Sikeresen törölte a csoportot",
    EMPTY_GROUP_LIST_MSG:"Nem lett létrehozva csoport. Először hozzon létre egyet!",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Sikeresen törölte a felhasználót a csoportból",
    ADD_USER_TO_GROUP_NOTIFICATION:"Sikeresen hozzáadta a felhasználót a csoporthoz",
    ADD_USER_NOTIFICATION:"Az új felhasználó hozzáadása sikeres volt",
    DELETE_USER_NOTIFICATION:"A felhasználó törlése sikeres volt",
    RESEND_USER_VERIFICATION_EMAIL:"Sikeresen újraküldte az ellenőrző e-mailt",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Felhasználói csoport létrehozásához",
    DELETE_USER:"Felhasználó törlése",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Biztosan törölni akarja ezt a felhasználót a felhasználói csoportból?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Tisztelt R2W felhasználó",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Hűségprogram-szabály a látogatások száma szerinti bontásban",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Hűségprogram-szabály az elköltött zsetonok összege szerinti bontásban",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Hűségprogram-szabály a hét napjai szerinti bontásban",
    REMOVE_CAMPAIGN_RULE_TITLE:"Kampányszabály törlése",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Biztosan törölni akarja a kampányszabályt?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Sikeresen létrehozta az új kampányt",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Sikeresen aktiválta a kampányt",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Nem lett létrehozva kampány. Először hozzon létre egyet!",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Sikeresen elküldte az üzenetet",
    COMPANY_ACCOUNTS:"Vállalati fiókok",
    BUSSINESS_INVOICES_LIST:"Saját B2B számlám",
    LOCALE_TOKEN:"Helyi zsetonok",
    R2W:"Globális zsetonok",
    START_MONTH:"Kezdő hónap",
    END_MONTH:"Vég hónap",
    TOKEN_TYPE:"Zseton típus",
    TOKEN_NUMBER:"Zsetonok száma",
    NOTHING_TO_DISPLAY:"* Semmi nem látható",
    CREATE_INVOICE:"Számla létrehozása",
    INVOICE:"Számla",
    INVOICES:"Számlák",
    EDIT_INVOICE:"Számla szerkesztése",
    UPDATE_INVOICE_NOTIFICATION:"Sikeresen módosította a számla státuszát „Folyamatban levő”-re",
    CURRENT_CHARGES:"Az aktuális időszakot érintő változások",
    PAYMENTS_ON_HOLD:"Feldolgozás alatt álló számlák",
    FOR_INVOICING:"Számlázáshoz",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"A számla törlésére készül",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Biztosan törölni akarja ezt a számlát?",
    INVOICING_NOTIFICATION_HEADER:"A számlázásra készül",
    INVOICING_NOTIFICATION_TEXT:"Biztosan ki akar jelentkezni?",
    SENT_INVOICE_NOTIFICATION:"Sikeresen elküldte a számlát",
    CANCELED_INVOICE_NOTIFICATION:"Sikeresen törölte a számlát",
    INVOICE_DESCRIPTION_TEXT:"Számla",
    INVOICE_STATE:"Számla státusza",
    INVOICE_NUMBER:"Számlaszám",
    INVOICE_TOTAL:"Összesen",
    SELECT_YEAR:"Év kiválasztása",
    DOWNLOAD:"PDF-fájl letöltése",
    INVOICE_NUMBER_HEADER:"      számú számla elküldésére készül",
    INVOICE_PAYMENT_CONFIRMATION:"      kifizetésének megerősítésére készül",
    INSERT_INVOICE_NUMBER:"Számlaszám megadása",
    INVOICED_WARNING:"Az e-mail elküldése meghiúsult. Kérjük, várjon...",
    SEND_INVOICE:"Küldés",
    INVOICE_ALL:"Mind",
    INVOICE_FROM_R2W:"Az R2W-től",
    INVOICE_TO_R2W:"Az R2W-nek",
    PAYMENT_REQUEST:"Fizetési kérelem",
    PAYMENT_REQUEST_STATE:"Fizetési kérelem állapota",
    PAYMENT_REQUEST_NUMBER:"Fizetési kérelem száma",
    FOR_PAYMENT_REQUEST:"Fizetési kérelmek",
    PAYMENT_REQUEST_ON_HOLD:"Fizetési kérelmek feldolgozásban",
    DOWNLOAD_INVOICE:"Számla letöltése",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kattintson a letöltési beállításokhoz",
    B2B_SPEC:"B2B Leírás",
    B2C_SPEC:"B2C Leírás",
    DOWNLOAD_PAYMENT_REQUEST:"Fizetési kérelem letöltése",
    LOYALTY_PREVIEW:"Hűségprogram előnézet",
    ACTIVATED:"Aktiválva",
    RUNNING:"Folyamatban",
    NOT_ACTIVATED:"Nincs aktiválva",
    FINISHED:"Kész",
    DEPRECATED:"Érvénytelenítve",
    UPCOMING:"Következő",
    NONE:"Egyik sem",
    STARTED:"Kezdés",
    ENDS:"Vége",
    DEDICATED:"Számára",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Ön kampány aktiválására",
    CAMPAIGN:"készül",
    SEND_MESSAGE_NOTIFICATION:"Ön arra készül, hogy üzenetet küldjön bizonyos felhasználói csoportoknak",
    DIVISIBLE_TO_NUMBER:"A számnak oszthatónak kell lennie ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Eszköztípus",
    LISTENER:"Kis gépek",
    BRIDGE:"Mosódobozok",
    WASH_BOXES:"Mosódobozok",
    VACUUMS:"Porszívók",
    SAVE_NEWS:"Hírek mentése",
    CREATE_NEW_NEWS:"Új hírek létrehozása",
    HISTORY_OF_ALL_NEWS:"Az összes korábbi hír megjelenítése",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Autómosó nevének beírása",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Másik autómosó hozzáadása",
    NEWS_TEXT:"Hír szövege",
    NEWS_TITLE:"Hír címe",
    DELETE_NEWS_CONFIRMATION:"Ön hír törlésére készül",
    NEWS_DELETE_NOTIFICATION:"Sikeresen törölte a hírt",
    NEWS_SAVE_NOTIFICATION:"Sikeresen mentette a hírt",
    NEWS_CREATION_DATE:"Létrehozás dátuma",
    NO_TITLE:"Nincs cím",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"A hír szövege nem lehet 255 karakternél hosszabb",
    NEWS_TEXT_REQUIRED_VALIDATION:"Be kell írni a hír szövegét",
    NEWS_TITLE_REQUIRED_VALIDATION:"Be kell írni a hír címét",
    DEACTIVATE:"Deaktiválás",
    ASIDE_MENU_LOCAL_TOKENS:"Helyi zsetonok",
    CREATE_NEW_LOCAL_TOKENS:"Új helyi zsetonok kibocsátása",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Adja meg az ügyfél e-mail címét, és azt, hogy hány helyi zsetont szeretne kibocsátani az ügyfél számára",
    CREATE_TOKENS:"Zsetonok kibocsátása",
    MINIMUM_ONE_TOKEN:"Az értéknek nagyobbnak kell lenni nullánál",
    CUSTOMER_EMAIL:"Az ügyfél e-mail címe",
    AMOUNT_OF_TOKENS:"A zsetonok száma",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Helyi zsetonok sikeres kibocsátása a következő számára:",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Hiba történt a helyi zsetonok kibocsátása során. Kérjük, hogy ellenőrizze az ügyfél e-mail címét és próbálja újra!",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"A kibocsátott helyi zsetonok áttekintése",
    ISSUED_AT:"Kibocsátva:",
    ISSUED_BY:"Kibocsátotta:",
    CODE:"Beváltási kód",
    REDEEMED_BY:"Beváltotta:",
    REDEEMED_AT:"Beváltás:",
    ASIDE_MENU_VOUCHERS:"Kuponok",
    PRINT:"Nyomtatás",
    VOUCHERS_OVERVIEW:"Kuponok áttekintése",
    CREATE_NEW_VOUCHERS:"Új kuponok létrehozása",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Új beváltható kupontétel létrehozása az egy kuponra jutó zsetonok számának megadásával",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Egy kuponra jutó zsetonok száma",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Egy kuponhoz 1 és 20 közötti számú zsetont rendelhet hozzá",
    NUMBER_OF_NEW_VOUCHERS:"Létrehozni kívánt kuponok száma",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Egy tételen belül 1 és {{méret}} közötti számú kupon hozható létre",
    NEW_VOUCHERS_PREFIX:"Új kuponsorozat kódjának előtagja",
    VALIDATION_VOUCHER_PREFIX:"A kód előtagját nagybetűkkel kell megadni, és 1 és 16 közötti számú betű, ill. számjegy alkothatja.",
    PROBLEM_CREATING_NEW_VOUCHERS:"Az új kuponok létrehozása során hiba történt. Kérjük, próbálja újra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal!",
    CREATE_VOUCHERS:"Kuponok létrehozása",
    CREATING_VOUCHERS_SUCCESS:"Az új kuponok létrehozása sikeres volt",
    PRINT_NEW_VOUCHERS:"Kuponok nyomtatása",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Adja meg a kuponsorozat kódjának előtagját, ha a teljes kuponsorozatot ki akarja nyomtatni! Másik lehetőség:",
    PRINT_VOUCHERS_PREFIX:"Kupon(sorozat) kódjának előtagja",
    NO_VOUCHERS_FOR_PRINT:"Nincs a megadott kód-előtagnak megfelelő kupon, amelyet kinyomtathatnánk",
    PRINT_VOUCHERS:"Kupon(ok) nyomtatása",
    VALIDATION_VOUCHER_CODE_FILTER:"A kuponok kereséséhez használt kifejezésnek nagybetűkből és számjegyekből kell állnia",
    FILTER_VOUCHERS_BY_CODE:"Kuponok keresése beváltási kód alapján",
    FILTER_VOUCHERS:"Kuponok keresése",
    WASH_BOX:"Mosó beálló",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Felhasznált digitális zsetonok összesen",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Az adott napon megvásárolt helyi zsetonok összesen",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Az adott napon elköltött helyi zsetonok összesen",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Az adott napon kiadott helyi zsetonok összesen",
    LOCAL_TOKEN:"Helyi zseton",
    GIVEN_TOKEN:"Kiadott helyi zsetonok",
    SOLD_TOKEN:"Eladott helyi zsetonok",
    SMALL_MACHINES:"Kisberendezések",
    R2W_Listener:"Hallgató",
    HHANLE_DEVICE:"HHanle - Mosó beálló",
    CODE_PREFIX_EXIST:"A kód-előtag már létezik",
    CODE_PREFIX_EXIST_TEXT:"Nem hozhat létre új kupont ezzel a kód-előtaggal. Állítson be másikat",
    MIN_FOUR_VALIDATION:"Legalább 4 karakter",
    ALL_INFORMATION_1:"Minden információ",
    ALL_INFORMATION_2:"el fog veszni",
    ASIDE_MENU_TRANSACTIONS:"Tranzakciók",
    EXPENSES:"Költségek",
    TOPUPS:"Feltöltések",
    EXPENSES_LIST:"Költségek listája",
    USER_EMAIL:"Felhasználói e-mail",
    COMPANY_NAME:"Cégnév",
    TOPUPS_LIST:"Feltöltések listája",
    CONSUMER:"Felhasználó",
    SYSTEM_ADMIN:"Rendszeradminisztrátor",
    MERCHANT_ADMIN:"Kereskedő-adminisztrátor",
    COMPANY_ADMIN:"Vállalati adminisztrátor",
    FACILITY_ADMIN:"Autómosó adminisztrátor",
    SUBSCRIBER:"Feliratkozó",
    CONFIGURATOR:"Konfiguráló",
    SETUP_UNIT_SERIAL_NO:"Serial number",
    SETUP_UNIT_MATERIAL_NO:"Material number",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi version",
    TOTAL_TURNOVER:"Autómosó forgalma",
    AVAILABILITY_ALL:"Availability",
    AVAILIBILITY:"Wash boxes availability:",
    AVAILABILITY_VACUUMS:"Vacuums availability:",
    WASH_BOX_INFO:"Wash boxes info",
    VACUUM_CLEANER_INFO:"Vacuum cleaners info",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Holidays",
    HOLIDAY:"Ünnep nap",
    LIGHTS_ON:"Lights/on",
    LIGHTS_OFF:"Lights/off",
    WASH_BOXES_ON:"Wash box/on",
    WASH_BOXES_OFF:"Wash box/off",
    VACUUMS_ON:"Vacuums/on",
    VACUUMS_OFF:"Vacuums/off",
    TURNOVER:"Turnover",
    TURNOVER_MANUAL_WASH_UNIT:"Turnover manual",
    STATUS_BAY_RUN_TIME:"Wash box total work time",
    STATUS_BAY_PROGRAM_NAME:"Program name",
    STATUS_BAY_CREDIT:"Wash box credit",
    CLOUD_KREDIT:"Cloud credit",
    STATUS_VACUUM_RUN_TIME:"Vacuum total work time",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facility services, wash box program and current fault data information",
    UNAVAILABLE:"Unit is unavailable",
    SHOW_HIDE_TABLE:"Show/hide working hours table",
    PROGRAM_NAME:"Program name",
    PROGRAM_OPTION:"Program option",
    DEVICE:"Device",
    QUANTITY:"Quantity",
    PROGRAM_COUNTER:"Program counter",
    NO_NAME:"Reference has no name",
    COUNTER_SERVICE_DATA:"Service data",
    NEED_SERVICE:"Szerviz szükséges",
    PROGRAM_DATA:"Wash box program data",
    CURRENT_FAULT_DATA:"Current fault data",
    REFERENCE_DUE:"Due",
    REFERENCE_SECONDS:"Seconds",
    REFERENCE_NAME:"Part name",
    WASHBOX_NAME:"Wash box name",
    FAULT_NAME:"Fault name",
    FAULT_NUMBER:"Fault number",
    CURRENT_FAULT_COUNT:"Active faults",
    DEVICE_NOT_INSTALLED:"Device not installed",
    STATUS_READY:"Kész állapot",
    STATUS_ERROR:"Hiba állapota",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Szoftver hiba",
    SOFTWARE_RESET:"Szoftver hiba",
    EXTERNAL_PIN_RESET:"Szoftver hiba",
    RESTART_OR_BROWNOUT_OCCURRED:"Szoftver hiba",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardver hiba",
    COULD_NOT_SIMULATE_COIN:"Hardver hiba",
    ERROR_SETTING_INHIBIT_MODE:"Hardver hiba",
    OFFLINE_DEVICE:"Offline autómosó",
    TARIFFS:"Tarifák",
    DAY:"Nap",
    NIGHT:"Éjszaka",
    VOUCHER_CODE:"Kupon kód",
    DISMISS_ALARM:"Riasztás visszaállítása?",
    ALARM_ACTIVE:"Aktív riasztások",
    NO_ALARM_ACTIVE:"Nincsenek aktív riasztások",
    ALARM_HISTORY:"Riasztási előzmények",
    MANAGING_TOKENS:"Zsetonok kezelése",
    EXPIRATION_DATE:"Lejárati dátum",
    EXTEND_TOKEN_DATE:"Hosszabbítsa meg a zseton lejárati dátumát a következőnél",
    DELETE_TOKENS_FOR:"Zsetonok törlése:",
    PUMP_TYPE:"Szivattyú típusa",
    TURN_OFF_DEVICE:"Eszköz állapota",
    OPERATION_DATA:"Működési adatok",
    PUMP_DATA:"Szivattyú adatok",
    PUMP_NAME:"Szivattyú neve",
    POINT_NAME:"Pont neve",
    CHANGER_INCOME:"A pénzváltó összes bevétele dátum szerint",
    SELECTED_OPEN:"Nyitva a kiválasztott munkaidőben",
    ALWAYS_OPEN:"Mindig nyitva (24/7)",
    CLOSED:"Zárva",
    CLOSED_24:"24 órát zárva",
    OPENED_24:"24 órát zárva",
    MON:"Hétfő",
    TUE:"Kedd ",
    WED:"Szerda ",
    THU:"Csütörtök ",
    FRI:"Péntek ",
    SAT:"Szombat ",
    SUN:"Vasárnap ",
    PRICING:"Árazás",
    PRICE:"Ár",
    VALIDITY:"Érvényesség",
    TOKEN_PACKAGES:"Zseton csomagok",
    SINGLE_WASH:"Egyszeri mosás",
    FACILITY_WORKING_HOURS:"Állítsa be a kiválasztott autómosó munkaidejét",
    WORKING_HOURS_ALWAYS_OPEN:"Mindig nyitva",
    WORKING_HOURS_ALWAYS_CLOSE:"Üzemeltető által zárva",
    WORKING_HOURS_CUSTOM:"Állítsa be a munkaidőt",
    KARCHER_ERROR_CODE:"Figyelmeztető hibakód",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Szervezet",
    CREATE_ORGANIZATION:"Szervezet létrehozása",
    CREATE_ORGANIZATION_AS:"Alszervezet létrehozása",
    DELETE_ORGANIZATION:"Szervezet törlése",
    EDIT_ORGANIZATION:"Szervezet szerkesztése",
    SUPPORTED_ORG_NAME:"Támogatott szervezet",
    SUPPORTED_ORG_TYPE:"Támogatott típus",
    ORG_NAME:"Név",
    ORG_TYPE:"Típus",
    SET_ORG_TITLE:"Alszervezet beállítása",
    SET_SUPPORTED_ORG_TITLE:"Támogatott alszervezet beállítása",
    SAVE_ORGANIZATION:"Szervezet mentése",
    SELECT_ORGANIZATION_TYPE:"Válassza ki a szervezet típusát",
    SELECT_ORGANIZATION_SELECTOR:"Válassza ki",
    SELECT_SUPPORTED_ORGANIZATION:"Válassza ki a támogatott szervezetet",
    ORGANIZATION_DELETED:"Szervezet sikeresen törölve",
    ORGANIZATION_SAVED:"Szervezet sikeresen mentve",
    ORGANIZATION_UPDATED:"A szervezet sikeresen frissítve",
    ALERTS:"Figyelmeztetések",
    DEVICE_STATUS:"Eszköz állapota",
    SITE_DETAILS:"Hely részletei",
    ALARM_STATUS:"Figyelmeztetés állapota",
    FILTER:"Szűrés alapján ...",
    FILTER_BY_ALERT_CENTER:"Szűrés kód, név vagy leírás alapján",
    TOTAL_ALARM:"Összes",
    LOW_ALARM:"Esemény",
    MEDIUM_ALARM:"Üzemzavar",
    HIGH_ALARM:"Kritikus hiba",
    NO_FACILITIES_NEARBY:"A közelben nincsenek autómosók",
    GRAY_MAP:"Szürke stílusú térkép",
    READY:"Rendelkezésre áll",
    WARNING:"Üzemzavar",
    ERROR:"Hiba",
    SITE_NAME:"Hely neve",
    ACCOUNTS_INFO:"Számlainformáció",
    USER_ORGANIZATION:"Felhasználói szervezet",
    ADD_USER_ORGANIZATION:"Új szervezeti felhasználó hozzáadása",
    EDIT_USER_ORGANIZATION:"Szervezet felhasználóinak szerkesztése",
    SELECT_ROLE:"Válasszon szerepet",
    SELECT_ORGANIZATION:"Válasszon szervezetet",
    SELECT_USER:"Válasszon felhasználót",
    USER_FOR_ORGANIZATION_CREATED:"Új felhasználó sikeresen létrehozva",
    SELECT_REGION:"Válasszon régiót",
    SELECT_LANGUAGE:"Válasszon nyelvet",
    LOADING_DATA:"Adatok betöltése, kérem várjon...",
    ADMINISTRATOR:"Adminisztrátor",
    TECHNICAL_SUPPORT:"Technikai támogatás",
    CONTROLLER:"Vezérlő",
    EDIT_ORGANIZATION_USER:"Szervezet felhasználóinak szerkesztése",
    DELETE_ORGANIZATION_USER:"Törölje a szervezet felhasználóit",
    USER_UPDATED:"Felhasználó sikeresen frissítve",
    USER_CREATED:"Felhasználó sikeresen létrehozva",
    ADDRESS:"Cím",
    SUBSCRIPTIONS:"Előfizetések",
    RESOLVED_STATUS:"Megoldva",
    NOT_RESOLVED_STATUS:"Nincs megoldva",
    ALERT_NAME:"Figyelmeztetés neve",
    ALERT_DESCRIPTION:"Figyelmeztetés leírása",
    ALERT_CODE:"Figyelmeztető kód",
    ALERT_TYPE:"Figyelmeztetés típusa",
    UNSUBSCRIBE:"Leiratkozási figyelmeztetés",
    SUBSCRIBE:"Feliratkozási figyelmeztetés",
    ALARM_SUBSCRIBED:"Sikeres előfizetés",
    UNSUBSCRIBED_CONFIRM:"Leiratkozik?",
    ALARM_UNSUBSCRIBED:"Sikeresen leiratkozott",
    ASIDE_MENU_CASHLESS_SALES:"Készpénz nélküli értékesítés",
    FILTERED_CASHLESS_PAYMENTS:"Szűrt készpénz nélküli fizetések",
    REFUND_DIALOG_TITLE:"Tranzakció viszatérítése?",
    REFUND_DIALOG_SUBTITLE:"Az összeg kisebb vagy egyenlő lehet, mint a tranzakció összege",
    REFUND:"Visszatérítés",
    INPUT_NOT_VALID:"A bevitel nem érvényes",
    REFUND_SUCCESSFULLY:"A kiválasztott fizetés visszatérítése sikeresen megtörtént",
    USER:"Felhasználó",
    TRANSACTION_ID:"PSP hivatkozás",
    DEVICE_ID:"Eszköz azonosító",
    NET_AMOUNT:"Nettó összeg",
    TRANSACTION_STATUS:"Tranzakció állapota",
    REPORT_NAME:"Kimutatás neve",
    TIME_FRAME:"Időkeret",
    SUB_POINT:"Válassza ki az alpontot",
    SUB_POINT_LIST_NOT_EXIST:"A kiválasztott mosási lehetőséghez nem létezik alpontlista",
    FACILITY_TYPE:"Autómosó típusa",
    MACHINE_NAME:"A gép neve",
    WASH_FACILITY_DETAILS:"A mosási lehetőség részletei",
    WASH_BAY_DETAILS:"Mosóhely részletei",
    DEVICES_INFO:"Eszközök listája",
    OPERATION_TIME_INFO:"Működési idő",
    OPERATION_TIME_VACUUM_INFO:"Porszívók működési ideje",
    OPERATION_TIME_ILLUMINATION_INFO:"A megvilágítás működési ideje",
    AVAILABLE_TITLE:"Elérhető",
    UNAVAILABLE_TITLE:"Nem érhető el",
    CURRENT_PROGRAM:"Aktuális program",
    CREDITS:"Kredit",
    DEVICE_NAME:"Eszköz neve",
    ACTIVE_ALARMS:"Aktív riasztások",
    ALL_DAY:"Egész nap",
    OPERATING_TIME_WASH_FACILITY:"Önkiszolgáló mosórendszer",
    OPERATING_TIME_VACUUMS:"Porszívók",
    OPERATING_TIME_ILLUMINATION:"Megvilágítás",
    OPERATION_COUNTERS:"Műveletszámlálók",
    EDIT:"Szerkesztés",
    WASHING_PROGRAMS:"Mosási programok",
    INFO:"Esemény",
    STATISTIC:"Statisztikai",
    ROLLOVER_DOSING:"Dosing",
    ROLLOVER_SPEED:" Speeds",
    ROLLOVER_RESETS:" Rollover remote reset",
    ROLLOVER_RESETS_INFO:" The remote reset has to be in accordance with local regulations. Important: Before resetting make sure that rollover is empty.",
    RESET_ROLLOVER:" Reset rollover",
    OPEN_DOOR_ROLLOVER:" Open",
    ROLLOVER_OPEN_DOOR_INFO:"Open wash hall door. Be careful.",
    ROLLOVER_OPEN_DOOR:" Open the door",
    APPLY_DOSING_CHANGES:" Apply dosing changes",
    APPLY_SPEED_CHANGES:" Apply speed changes",
    ACTUATION_SUCCESS:"Request sent",
    REMAINING_TIME:" Remaining time",
    OPEN_24H:" Open 24 hours",
    CLOSE_24H:" Close 24 hours",
    VALIDATION_OPERATION_TIME:" Format not correct. Use hh:mm",
    ROLLOVER:" Rollover",
    UPDATE_WASHING_PROGRAM:" Update washing program",
    UPDATE_ACTUATORS:"Update actuators",
    OPEN_ROLOVER_DOOR_TITLE:" Want to open rollover door?",
    OPEN_ROLOVER_DOOR_CONTENT:" Are you sure you want to open the door?",
    RESET_ROLOVER_TITLE:" Want to reset rollover?",
    RESET_ROLOVER_CONTENT:" Are you sure you want to reset rollover?",
    G0:"{{brand === 'r2w' ? 'Autómosó beálló 0' : 'Autómosó beálló 1'}}",
    G1:"{{brand === 'r2w' ? 'Autómosó beálló 1' : 'Autómosó beálló 2'}}",
    G2:"{{brand === 'r2w' ? 'Autómosó beálló 2' : 'Autómosó beálló 3'}}",
    G3:"{{brand === 'r2w' ? 'Autómosó beálló 3' : 'Autómosó beálló 4'}}",
    G4:"{{brand === 'r2w' ? 'Autómosó beálló 4' : 'Autómosó beálló 5'}}",
    G5:"{{brand === 'r2w' ? 'Autómosó beálló 5' : 'Autómosó beálló 6'}}",
    G6:"{{brand === 'r2w' ? 'Autómosó beálló 6' : 'Autómosó beálló 7'}}",
    G7:"{{brand === 'r2w' ? 'Autómosó beálló 7' : 'Autómosó beálló 8'}}",
    G8:"{{brand === 'r2w' ? 'Autómosó beálló 8' : 'Autómosó beálló 9'}}",
    G9:"{{brand === 'r2w' ? 'Autómosó beálló 9' : 'Autómosó beálló 10'}}",
    G10:"{{brand === 'r2w' ? 'Autómosó beálló 10' : 'Autómosó beálló 11'}}",
    U0:"{{brand === 'r2w' ? 'Porszívó 0' : 'Porszívó 1'}}",
    U1:"{{brand === 'r2w' ? 'Porszívó 1' : 'Porszívó 2'}}",
    U2:"{{brand === 'r2w' ? 'Porszívó 2' : 'Porszívó 3'}}",
    U3:"{{brand === 'r2w' ? 'Porszívó 3' : 'Porszívó 4'}}",
    U4:"{{brand === 'r2w' ? 'Porszívó 4' : 'Porszívó 5'}}",
    U5:"{{brand === 'r2w' ? 'Porszívó 5' : 'Porszívó 6'}}",
    U6:"{{brand === 'r2w' ? 'Porszívó 6' : 'Porszívó 7'}}",
    U7:"{{brand === 'r2w' ? 'Porszívó 7' : 'Porszívó 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Riasztási központ jelentést hozott létre a kiválasztott helyre az irányítópultról",
    ALERT_CENTER_TITLE_BY_FACILITY:"Riasztási központ jelentést hozott létre a kiválasztott autómosó által az irányítópultról",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Riasztási központ jelentés",
    ERROR_MESSAGE_403:"Nincs jogosultsága ennek az API-hívásnak a használatára. Hibakód: 403",
    LAST_ACTIVE_PROGRAM:"Aktív program / Utolsó aktív program",
    PROGRAM_ID:"Program szám",
    PROGRAM_PRICE:"Program ár",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Utántöltés szükséges",
    EMPTY_CHEMICAL_LEVEL:"Üres",
    CHEMICAL_LEVEL:"Level indication detergents (%)",
    ROLLOVER_STATUS:" Rollover status",
    ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
    ROLLOVER_STATUS_CODE_1:" Outside operating time",
    ROLLOVER_STATUS_CODE_2:" Program entry allowed",
    ROLLOVER_STATUS_CODE_3:"Position your vehicle",
    ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
    ROLLOVER_STATUS_CODE_5:"Vehicle back",
    ROLLOVER_STATUS_CODE_6:"Vehicle stop",
    ROLLOVER_STATUS_CODE_7:"Wash active",
    ROLLOVER_STATUS_CODE_8:"Wash stopped",
    ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
    ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
    ROLLOVER_STATUS_CODE_11:"Emergency stop",
    ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
    ROLLOVER_STATUS_CODE_13:"Anti frost active",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
    ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Kritikus hiba",
    NO_ALARM:"Nincs kritikus hiba",
    SOFTWARE_VERSION:"Szoftver verzió",
    SOFTWARE_DATE:"Szoftver dátum",
    SITE_ADDRESS:"Hely címe",
    SECONDS:"Másodpercek",
    SERVICE_PART_NAME:"Szolgáltatás neve:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Működési és szolgáltatási számláló",
    OPERATION_COUNTER:"Működési számláló",
    SERVICE_COUNTER:"Szolgáltatási számláló",
    FAULT_CODE:"Figyelmeztetési kód",
    PRESSURE_TITLE:"Légnyomás",
    TIME_TITLE:"Jelenlegi idő",
    COUNTRY_TITLE:"Ország",
    CITY_TITLE:"Város",
    REGION_TITLE:"Régió",
    SELECT_POINTS_TO_SEARCH:"Select points ...",
    LOGS_HISTORY:"Paraméterváltozás előzményei",
    ACTUATOR_REFERENCE:"Aktuátor referencia",
    ACTUATOR_VALUE:"Aktuátor érték",
    POINT_ID:"Pont azonosító",
    VALIDATION_NOT_VALID_RANGE:"Hibás tartomány",
    ENABLE_ROLLOVER_RESET:"A jelölőnégyzet bepipálásával megerősíti, hogy elolvasta és elfogadja a biztonsági utasításokat.",
    CHANGE_OF_PARAMETERS:"Paraméterek módosítása",
    SELECT_OPTIONS:"Opciók kiválasztása",
    AUTOMATIC:"Automatikus",
    DESALTING:" Sómentesítő funkció",
    SEASON_WASH:"Szezonális mosási programok",
    SPRING_PROGRAM:"Tavaszi mosási programok",
    SUMMER_PROGRAM:"Nyári mosási programok",
    AUTUMN_PROGRAM:"Őszi mosási programok",
    WINTER_PROGRAM:"Téli mosási programok",
    DOOR_CONTROL:"Ajtóvezérlés",
    SUMMER_DOOR_CONTROL:"Nyár, nyári üzemmódban működtetett kapuvezérléssel",
    WINTER_DOOR_CONTROL:"él, téli üzemmódban működtetett kapuvezérléssel",
    APPLY_PARAMETERS_CHANGES:"Paraméterváltozások alkalmazása",
    WORKING_SCHEDULES:"Munkarendek",
    HOLIDAY_SCHEDULES:"Üdülési ütemtervek",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Ünnepek a helyszínen sikeresen létrehozva",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Ünnepek a helyszínen sikeresen frissítve",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Ünnepnapok a helyszínen sikeresen törölve",
	WORKING_SCHEDULES_SUCCESSFULLY_UPDATED:"Munkarendek a helyszínen sikeresen frissítve",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Munkarendek sikeresen átvitelre kerültek",
    HOLIDAY_SUCCESSFULLY_DELETED:"Üdülés sikeresen törölve",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Drying agent with low filling level",
    CHEM_LEVEL_LOW_SHAMPOO:"Shampoo with low filling level",
    CHEM_LEVEL_LOW_FOAM:"Foam with low filling level",
    CHEM_LEVEL_LOW_WAX_1:"Wax with low filling level",
    CHEM_LEVEL_LOW_POLISH_1:"Polish with low filling level",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Rim cleaner with low filling level",
    CHEM_LEVEL_LOW_WAX_2:"Wax with low filling level",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Tyre shine with low filling level",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Insect remover with low filling level",
    CHEM_LEVEL_LOW_POLISH_2:"Polish with low filling level",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensive with low filling level",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Foam rain with low filling level",
    CHEM_LEVEL_DRYING_AGENT:"Filling level drying agent",
    CHEM_LEVEL_SHAMPOO:"Filling level shampoo",
    CHEM_LEVEL_FOAM:"Filling level foam",
    CHEM_LEVEL_WAX_1:"Filling level wax",
    CHEM_LEVEL_POLISH_1:"Filling level polish",
    CHEM_LEVEL_RIM_CLEANER:"Filling level rim cleaner",
    CHEM_LEVEL_WAX_2:"Filling level wax",
    CHEM_LEVEL_TYRE_SHINE:"Filling level tyre shine",
    CHEM_LEVEL_INSECT_REMOVER:"Filling level insect remover",
    CHEM_LEVEL_POLISH_2:"Filling level polish",
    CHEM_LEVEL_INTENSIVE:"Filling level intensive ",
    CHEM_LEVEL_FOAM_RAIN:"Filling level foam rain",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Service counter roof-brush lifting belt",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Service counter dryer lifting belt",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Service counter motor cable roof-brush",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Service counter fresh water pump service",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Service counter pump service used water",
    DRYING_AGENT:"Drying agent",
    FOAM_DRYING_AGENT:"Foam drying agent",
    SHAMPOO:"Shampoo",
    FOAM:"Foam",
    BRUSH_FOAM:"Brush foam",
    WAX_1:"Wax",
    FOAM_WAX_1:"Foam wax",
    POLISH_1:"Polish",
    RIM_CLEANING:"Rim cleaner",
    WAX_2:"Wax",
    FOAM_WAX_2:"Foam wax",
    TYRE_SHINE:"Tyre shine",
    INSECT_REMOVER:"Insect remover",
    POLISH_2:"Polish",
    INTENSIVE_BASIC:"Intensive basic",
    INTENSIVE_SIDE:"Intensive side",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensive roof spray bar",
    TAR_REMOVER:"Tar remover",
    UNDER_CHASSIS_CONVERSATION:"Under chassis conversation",
    STATIONARY_PRE_SPRAY_ARCH:"Stationary pre-spray arch",
    FOAM_RAIN:"Foam rain",
    PRE_CLEANING:"Pre-cleaning",
    BRUSH:"Brush",
    CARE:"Care",
    DRYING:"Drying",
    DRYING_LOW_NOISE:"Drying reduced noise",
    INTENSIVE_CLEANING:"Intensive cleaning",
    BRUSH_CLEANING:"Brush cleaning",
    EMPTY_RUN:"Empty run",
    DRYING_AID:"Drying aid",
    WAX:"Wax",
    FOAM_WASH:"Foam wash",
    POLISH:"Polish",
    FOAM_POLISH:"Foam polish",
    WHEEL_CLEANING:"Wheel cleaning",
    HIGH_PRESSURE_ROOF:"Roof high pressure",
    HIGH_PRESSURE_SIDE:"Side high pressure",
    DRYER_FORWARD:"Dryer forward",
    DRYER_BACKWARD:"Dryer backward",
    DELETE_ALL_HOLIDAYS:"A kiválasztott hely összes ünnepének törlése",
    CREATE_NEW_HOLIDAY:"Új létrehozása",
    RESET_INPUTS:"Minden üdülési adat visszaállítása",
    TWENTY_FOUR_HOURS_OPEN:"24 órás nyitva tartás",
    EVERY_YEAR:"Éves",
    DELETE_HOLIDAY:"Üdülés törlése",
    ADD_NEW_HOLIDAY:"Új üdülés hozzáadása",
    HOLIDAYS_LIST:"Meglévő üdülések listája",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Törli az összes ünnepnapot a kiválasztott helyen?",
    VALIDATION_HOLIDAY_DATE:"Format not correct. Use mm-dd",
    FOR_DATE:"For date",
    WITH_ID:"With ID",
    FROM_HOURS:"From (h)",
    FROM_MINUTES:"From (min)",
    TO_HOURS:"To (h)",
    TO_MINUTES:"To (min)",
    NOT_MATCH:"Not match",
    START:"Start",
    STOP:"Stop",
    DAILY_TIME:"24 hours list",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individual time setting",
    PROGRAM_NOT_STARTED:"Program not started yet",
    JETWASH:"Self-service wash system",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Friss víz szivattyú",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Feldolgozó víz szivattyú",
    OPERATION_COUNTER_HP_PUMP_1:"Nagy nyomású szivattyú 1",
    OPERATION_COUNTER_HP_PUMP_2:"Nagy nyomású szivattyú 2",
    RELEASE_NOTES:"Alkalmazás verziók és kiadási megjegyzések",
    BACKEND_RELEASE_NOTES:"Platform kiadási megjegyzések:",
    FRONTEND_RELEASE_NOTES:"Webalkalmazás kiadási megjegyzések:",
    SELECTED_FACILITY_TIMEZONE:"Kiválasztott autómosó időzónája",
    REFRESH_PAGE:"Oldal frissítése",
    REFRESH_MAPS:"Térképek frissítése",
    PUMPS:"Szivattyúk",
    RUN_TIME:"Futási idő ",
    RUN_TIME1:"Futási idő 1",
    RUN_TIME2:"Futási idő 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuátor futási időhöz",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuátor futási idő 1-hez",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuátor futási idő 2-höz",
    PUMP_RUN_TIME_MIN_VALIDATION:"Min érték 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Max érték 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Ár formátum használata x.xx",
    ACTUATION_NOT_ALLOWED:"Aktuálás nem engedélyezett a jelenlegi felhasználói szerepkörhöz",
    MAINTENANCE_DAYS:"Karbantartási napok",
    MAINTENANCE_WASHES:"Karbantartási mosások",
    DAILY_FINANCES_POS:"POS ",
    POS_INCOME:"Összes jövedelem POS",
    PROPAGATE:"Propagate",
    ALL_DAY_HOURS_SELECTOR:"24 órás típusválasztó",
    GET_OPERATING_TIME_FROM_SITE:"Kérje le az aktuális eszköz működési idejét a helyszíni munkarendből",
    USER_NOT_VALID:"A felhasználó érvénytelen. Próbálja meg egy másik fiók hitelesítő adataival.",
    VERIFIED:"Ellenőrzött",
    RESEND_VERIFICATION_MAIL:"Ellenőrző e-mail újraküldése",
    RETURN_TO_DASHBOARD:"Vissza a műszerfalhoz",
    ERROR_PAGE_BAD_REQUEST:"400 Hibás kérés.",
    WASHES:"Mosások száma",
    TIME_TO_SERVICE:"Szolgáltatás időpontja",
    ACCOUNT_ALREADY_ACTIVATED:"Fiók már aktiválva",
    DEVICE_EVENTS:"Eszköz események",
    DEVICE_EVENTS_LOG_PULLED:"Eszköz eseménynapló lekérve",
    EVENTS_PULL_DATE:"Események lekérési idő:",
    DEVICE_EVENTS_REFRESH:"Új eseményadatok lekérése",
    WEB_SOCKETS_CONNECTION_PROBLEM:" Websocket-kapcsolati probléma. Próbálja meg frissíteni az oldalt.",
    INSTALLATION_DATE:"Gép telepítési dátuma",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Forró viasz",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Nagy nyomású mosás",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Erőteljes peremhab",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Erőteljes hab",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Megállítás",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Habmosás HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Mosás",
    KARCHER_CUSTOM_PROGRAM_NAME_8:" Kiemelt ápolás",
    INFO_TITLE:"Információ",
    FOAM_WAX1:"Habviasz",
    POLISH1:"Polír",
    WAX1:"Viasz",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Az oldal részletei sikeresen frissítve",
    COMPANY:"Cég",
    FACILITY_HAS_CHANGER:" Van váltó?",
    DISABLE_OFFLINE_ALARM:"R2W riasztások kikapcsolása",
    ASIDE_WORKING_SCHEDULES:"Alkalmazás oldal részletei",
    TERMS_OF_SERVICE_R2W_TITLE:"Ready2Wash szolgáltatási feltételek",
    TERMS_OF_SERVICE_R2W:"Ready2Wash szolgáltatási feltételek",
    DATA_PROCESSING_TITLE:"Adatok feldolgozva",
    PRIVACY_POLICY_TITLE:"Adatvédelmi irányelvek",
    READY_TO_PAY_TERMS_OF_SERVICE:"Ready2Pay szolgáltatási feltételek",
    TERMS_AND_SERVICES:"Feltételek és szolgáltatások",
    HOURLY: "Óránként",
    DAILY: "Naponta",
    WEEKLY: "Hetente",
    MONTHLY: "Havonta",
    YEARLY: "Évente",
    DELETE_ITEM_SUCCESS:"Sikeresen törölte az elemet",
    STATE: "Állapot",
    AVAILABILITY_STATUS_1: "Egység nyitva",
    AVAILABILITY_STATUS_2: "Egység zárva (szabadság)",
    AVAILABILITY_STATUS_3: "Egység zárva (üzemidő)",
    AVAILABILITY_STATUS_4: "Egység zárva (hiba)",
    AVAILABILITY_STATUS_5: "Egység zárva (egyéb)",
    AVAILABILITY_VACUUMS_STATUS_1: "Porszívók nincsenek telepítve",
    AVAILABILITY_VACUUMS_STATUS_2: "Porszívók nyitva",
    AVAILABILITY_VACUUMS_STATUS_3: "Porszívók zárva (szabadság)",
    AVAILABILITY_VACUUMS_STATUS_4: "Porszívók zárva (üzemidő)",
    AVAILABILITY_VACUUMS_STATUS_5: "Porszívók zárva (hiba)",
    AVAILABILITY_VACUUMS_STATUS_6: "Porszívók zárva (egyéb)",
    ECOM_AMOUNT: "Összesített Ecom minden helyszínre",
    CAPTURED: "Rögzítve",
    DELETE_COMPANY_HISTORY_INFO:"Ez a művelet törölni fogja a vállalata összes jelentésadatát. Ez a művelet nem vonható vissza.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Biztos benne, hogy véglegesen törölni szeretné az összes jelentésadatot?",
    VALUE_DATE: "Értéknap",
    KARCHER_EVENT_NAME_1: "Alap hőcserélő regenerálva",
    KARCHER_EVENT_NAME_2: "Alap hőcserélő regeneráció befejezve",
    KARCHER_EVENT_NAME_3: "Anyag / sorozatszám",
    KARCHER_EVENT_NAME_4: "A rendszer fertőtlenítve",
    KARCHER_EVENT_NAME_5: "HP szivattyú 1 fertőtlenítve",
    KARCHER_EVENT_NAME_6: "HP szivattyú 2 fertőtlenítve",
    KARCHER_EVENT_NAME_7: "HP szivattyú 3 fertőtlenítve",
    KARCHER_EVENT_NAME_8: "HP szivattyú 4 fertőtlenítve",
    KARCHER_EVENT_NAME_9: "HP szivattyú 5 fertőtlenítve",
    KARCHER_EVENT_NAME_10: "1. mosóállomás zárolva",
    KARCHER_EVENT_NAME_11: "2. mosóállomás zárolva",
    KARCHER_EVENT_NAME_12: "3. mosóállomás zárolva",
    KARCHER_EVENT_NAME_13: "4. mosóállomás zárolva",
    KARCHER_EVENT_NAME_14: "5. mosóállomás zárolva",
    KARCHER_EVENT_NAME_15: "6. mosóállomás zárolva",
    KARCHER_EVENT_NAME_16: "7. mosóállomás zárolva",
    KARCHER_EVENT_NAME_17: "8. mosóállomás zárolva",
    KARCHER_EVENT_NAME_18: "Frissítés elindítva",
    KARCHER_EVENT_NAME_19: "Frissítés befejezve",
    KARCHER_EVENT_NAME_20: "WS Reg kezdés",
    KARCHER_EVENT_NAME_21: "WS Reg befejezés",
    KARCHER_EVENT_NAME_22: "WS 75%-os érzékelő",
    KARCHER_EVENT_NAME_23: "Műszaki hiba",
    KARCHER_EVENT_NAME_24: "Üzemzavar",
    KARCHER_EVENT_NAME_25: "Egység bekapcsolva",
    KARCHER_EVENT_NAME_26: "Egység kikapcsolva",
    KARCHER_EVENT_NAME_27: "1. doboz lezárva",
    KARCHER_EVENT_NAME_28: "2. doboz lezárva",
    KARCHER_EVENT_NAME_29: "3. doboz lezárva",
    KARCHER_EVENT_NAME_30: "4. doboz lezárva",
    KARCHER_EVENT_NAME_31: "5. doboz lezárva",
    KARCHER_EVENT_NAME_32: "6. doboz lezárva",
    KARCHER_EVENT_NAME_33: "7. doboz lezárva",
    KARCHER_EVENT_NAME_34: "8. doboz lezárva",
    KARCHER_EVENT_NAME_35: "1. HP szivattyúállomás",
    KARCHER_EVENT_NAME_36: "2. HP szivattyúállomás",
    KARCHER_EVENT_NAME_37: "3. HP szivattyúállomás",
    KARCHER_EVENT_NAME_38: "4. HP szivattyúállomás",
    KARCHER_EVENT_NAME_39: "5. HP szivattyúállomás",
    KARCHER_EVENT_NAME_40: "6. HP szivattyúállomás",
    KARCHER_EVENT_NAME_41: "7. HP szivattyúállomás",
    KARCHER_EVENT_NAME_42: "8. HP szivattyúállomás",
    KARCHER_EVENT_NAME_43: "Égőfej",
    KARCHER_EVENT_NAME_44: "Égőfej ventilátor",
    KARCHER_EVENT_NAME_45: "Melegvíz szivattyú",
    KARCHER_EVENT_NAME_46: "Fagyvédő szivattyú",
    KARCHER_EVENT_NAME_47: "Ozmózis szivattyú",
    KARCHER_EVENT_NAME_48: "Padlófűtés",
    KARCHER_EVENT_NAME_49: "Tömlőfűtés",
    KARCHER_EVENT_NAME_50: "Mikro-/Felni tisztítás",
    KARCHER_EVENT_NAME_51: "Alvázmosó szivattyú",
    KARCHER_EVENT_NAME_52: "Habosító Booster szivattyú",
    KARCHER_EVENT_NAME_53: "1. porszívó",
    KARCHER_EVENT_NAME_54: "2. porszívó",
    KARCHER_EVENT_NAME_55: "3. porszívó",
    KARCHER_EVENT_NAME_56: "4. porszívó",
    KARCHER_EVENT_NAME_57: "5. porszívó",
    KARCHER_EVENT_NAME_58: "6. porszívó",
    KARCHER_EVENT_NAME_59: "7. porszívó",
    KARCHER_EVENT_NAME_60: "8. porszívó",
    KARCHER_EVENT_NAME_61: "9. porszívó",
    KARCHER_EVENT_NAME_62: "10. porszívó",
    KARCHER_EVENT_NAME_63: "11. porszívó",
    KARCHER_EVENT_NAME_64: "12. porszívó",
    KARCHER_EVENT_NAME_65: "Felni tisztítószivattyú",
    KARCHER_EVENT_NAME_66: "Mikroszivattyú",
    KARCHER_EVENT_NAME_67: "Intenzív szivattyú",
    KARCHER_EVENT_NAME_68: "1. porszívó turbinája",
    KARCHER_EVENT_NAME_69: "1. porszívó szűrője",
    KARCHER_EVENT_NAME_70: "2. porszívó turbinája",
    KARCHER_EVENT_NAME_71: "2. porszívó szűrője",
    KARCHER_EVENT_NAME_72: "3. porszívó turbinája",
    KARCHER_EVENT_NAME_73: "3. porszívó szűrője",
    KARCHER_EVENT_NAME_74: "4. porszívó turbinája",
    KARCHER_EVENT_NAME_75: "4. porszívó szűrője",
    KARCHER_EVENT_NAME_76: "5. porszívó turbinája",
    KARCHER_EVENT_NAME_77: "5. porszívó szűrője",
    KARCHER_EVENT_NAME_78: "6. porszívó turbinája",
    KARCHER_EVENT_NAME_79: "6. porszívó szűrője",
    KARCHER_EVENT_NAME_80: "7. porszívó turbinája",
    KARCHER_EVENT_NAME_81: "7. porszívó szűrője",
    KARCHER_EVENT_NAME_82: "8. porszívó turbinája",
    KARCHER_EVENT_NAME_83: "8. porszívó szűrője",
    KARCHER_EVENT_NAME_84: "9. porszívó turbinája",
    KARCHER_EVENT_NAME_85: "9. porszívó szűrője",
    KARCHER_EVENT_NAME_86: "10. porszívó turbinája",
    KARCHER_EVENT_NAME_87: "10. porszívó szűrője",
    KARCHER_EVENT_NAME_88: "11. porszívó turbinája",
    KARCHER_EVENT_NAME_89: "11. porszívó szűrője",
    KARCHER_EVENT_NAME_90: "12. porszívó turbinája",
    KARCHER_EVENT_NAME_91: "12. porszívó szűrője",
    INSERT_TOKEN: "Adja meg a tokeneket, és indítsa el a szolgáltatást",
    OPEN_SESSION: "A munkamenet sikeresen megnyílt",
    IN_PROGRESS: "Folyamatban ...",
    TOKEN_INSERTED: "A tokeneket sikeresen megadták",
    EXPIRED_SESSION: "A munkamenet lejárt",
    TWO_DIGIT_INTEGER_VALIDATION: "Legfeljebb kétszámjegyű egész számot használjon",
    KARCHER_OPERATION_COUNTER_1: "Mosóállomás 1 HP szivattyú",
    KARCHER_OPERATION_COUNTER_2: "Mosóállomás 1 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_3: "Mosóállomás 1 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_4: "Mosóállomás 1 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_5: "Mosóállomás 1 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_6: "Mosóállomás 2 HP szivattyú",
    KARCHER_OPERATION_COUNTER_7: "Mosóállomás 2 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_8: "Mosóállomás 2 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_9: "Mosóállomás 2 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_10: "Mosóállomás 2 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_11: "Mosóállomás 3 HP szivattyú",
    KARCHER_OPERATION_COUNTER_12: "Mosóállomás 3 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_13: "Mosóállomás 3 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_14: "Mosóállomás 3 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_15: "Mosóállomás 3 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_16: "Mosóállomás 4 HP szivattyú",
    KARCHER_OPERATION_COUNTER_17: "Mosóállomás 4 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_18: "Mosóállomás 4 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_19: "Mosóállomás 4 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_20: "Mosóállomás 4 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_21: "Mosóállomás 5 HP szivattyú",
    KARCHER_OPERATION_COUNTER_22: "Mosóállomás 5 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_23: "Mosóállomás 5 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_24: "Mosóállomás 5 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_25: "Mosóállomás 5 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_26: "Mosóállomás 6 HP szivattyú",
    KARCHER_OPERATION_COUNTER_27: "Mosóállomás 6 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_28: "Mosóállomás 6 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_29: "Mosóállomás 6 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_30: "Mosóállomás 6 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_31: "Mosóállomás 7 HP szivattyú",
    KARCHER_OPERATION_COUNTER_32: "Mosóállomás 7 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_33: "Mosóállomás 7 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_34: "Mosóállomás 7 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_35: "Mosóállomás 7 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_36: "Mosóállomás 8 HP szivattyú",
    KARCHER_OPERATION_COUNTER_37: "Mosóállomás 8 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_38: "Mosóállomás 8 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_39: "Mosóállomás 8 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_40: "Mosóállomás 8 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_41: "Ozmózisszivattyú",
    KARCHER_OPERATION_COUNTER_42: "Melegvíz-generátor",
    KARCHER_OPERATION_COUNTER_43: "Fagyvédő szivattyú",
    KARCHER_OPERATION_COUNTER_44: "WSO szűrőpatronok",
    KARCHER_OPERATION_COUNTER_45: "Mosóállomás fűtési szivattyú",
    KARCHER_OPERATION_COUNTER_46: "Melegvíz-szivattyú",
    KARCHER_OPERATION_COUNTER_47: "Habcső fűtése",
    KARCHER_OPERATION_COUNTER_48: "Kerékmosó szivattyú",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulziós szivattyú",
    KARCHER_OPERATION_COUNTER_50: "Intenzív habtakarék szivattyú",
    KARCHER_OPERATION_COUNTER_51: "Porszívó 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Porszívó 1 szűrő 1",
    KARCHER_OPERATION_COUNTER_53: "Porszívó 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Porszívó 1 szűrő 2",
    KARCHER_OPERATION_COUNTER_55: "Porszívó 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Porszívó 2 szűrő 1",
    KARCHER_OPERATION_COUNTER_57: "Porszívó 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Porszívó 2 szűrő 2",
    KARCHER_OPERATION_COUNTER_59: "Porszívó 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Porszívó 3 szűrő 1",
    KARCHER_OPERATION_COUNTER_61: "Porszívó 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Porszívó 3 szűrő 2",
    KARCHER_OPERATION_COUNTER_63: "Porszívó 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Porszívó 4 szűrő 1",
    KARCHER_OPERATION_COUNTER_65: "Porszívó 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Porszívó 4 szűrő 2",
    KARCHER_OPERATION_COUNTER_67: "Porszívó 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Porszívó 5 szűrő 1",
    KARCHER_OPERATION_COUNTER_69: "Porszívó 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Porszívó 5 szűrő 2",
    KARCHER_OPERATION_COUNTER_71: "Porszívó 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Porszívó 6 szűrő 1",
    KARCHER_OPERATION_COUNTER_73: "Porszívó 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Porszívó 6 szűrő 2",
    KARCHER_OPERATION_COUNTER_75: "Távolítsa el a kondenzvizet a kompresszorból",
    KARCHER_OPERATION_COUNTER_76: "Ellenőrizze a fagyvédelmi rendszert",
    KARCHER_OPERATION_COUNTER_77: "Égő ventilátora",
    KARCHER_OPERATION_COUNTER_78: "Habfelerősítő szivattyú",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Az adatlista több mint 10000 elemet tartalmaz",
    KARCHER_POINT_NAME_1: "Ünnepnap",
    KARCHER_POINT_NAME_2: "Hétfő",
    KARCHER_POINT_NAME_3: "Kedd",
    KARCHER_POINT_NAME_4: "Szerda",
    KARCHER_POINT_NAME_5: "Csütörtök",
    KARCHER_POINT_NAME_6: "Péntek",
    KARCHER_POINT_NAME_7: "Szombat",
    KARCHER_POINT_NAME_8: "Vasárnap",
    KARCHER_POINT_NAME_9: "Porszívók Ünnepnap",
    KARCHER_POINT_NAME_10: "Porszívók Hétfő",
    KARCHER_POINT_NAME_11: "Porszívók Kedd",
    KARCHER_POINT_NAME_12: "Porszívók Szerda",
    KARCHER_POINT_NAME_13: "Porszívók Csütörtök",
    KARCHER_POINT_NAME_14: "Porszívók Péntek",
    KARCHER_POINT_NAME_15: "Porszívók Szombat",
    KARCHER_POINT_NAME_16: "Porszívók Vasárnap",
    KARCHER_POINT_NAME_17: "Világítás Ünnepnap",
    KARCHER_POINT_NAME_18: "Világítás Hétfő",
    KARCHER_POINT_NAME_19: "Világítás Kedd",
    KARCHER_POINT_NAME_20: "Világítás Szerda",
    KARCHER_POINT_NAME_21: "Világítás Csütörtök",
    KARCHER_POINT_NAME_22: "Világítás Péntek",
    KARCHER_POINT_NAME_23: "Világítás Szombat",
    KARCHER_POINT_NAME_24: "Világítás Vasárnap",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR-kód",
    ACCEPT_TERMS_AND_CONDITIONS: "Felhasználási feltételek elfogadása",
    CREATE_AND_PRINT_VOUCHERS: "Kuponok létrehozása és nyomtatása",
    CODE_PREFIX_QUESTION: "Kód-előtag nincs megadva",
    CODE_PREFIX_QUESTION_TEXT: "Szeretné kód-előtag nélkül folytatni?",
    ISSUED_DATE: "Kibocsátás dátuma",
    VOUCHER_VALIDITY_DAYS: "Kupon érvényessége (napok)",
    VALIDATION_ONLY_NUMBERS: "Csak számok engedélyezettek",
    REPRINT_VOUCHERS: "Kuponok másolatának nyomtatása",
    EXPIRY_DATE: "Érvényes eddig",
    VOUCHER_TYPE_VACUUM: "Kupon: Porszívó",
    VOUCHER_TYPE_JETWASH: "Kupon: Jet Wash Care",
    VOUCHER_TYPE_MATT: "Kupon: Matt"
  });
})();
